/*
 *  -----------------------------------------------------------------------
 *    <copyright file="delete-reason-dialog/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import React, { ChangeEvent, useState } from 'react';
import { useBoolean, useTranslation } from '../../../../../hooks';
import { validateFields } from '../../../../../utils/validation';
import ActionDialog from '../../../core/action-dialog';
import CharactersRemaining from '../../../core/characters-remaining';
import TextField from '../../../core/text-field';
import { DeleteReasonDialogProps } from './delete-reason-dialog.interface';

const DeleteReasonDialog = ({ title, warning, handleClose, handleSubmit }: DeleteReasonDialogProps) => {
    const { t } = useTranslation();

    const [reason, setReason] = useState('');
    const [reasonError, setReasonError] = useState('');

    const disabledSave = useBoolean(true);

    const textFieldMaxLength = 1200;

    const handleReasonChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setReason(event.target.value);
        disabledSave.setFalse();
        const error = validateFields(event.target.value, 'reason', textFieldMaxLength, true);
        setReasonError(error?.reason ?? null);
    };

    return (
        <ActionDialog
            title={title}
            warning={warning}
            onClose={handleClose}
            onSubmit={() => handleSubmit(reason)}
            submitDisabled={!!reasonError || disabledSave.value}
            className="delete-reason-dialog"
        >
            <TextField
                label={`${t('cm:deleteReasonLabel')}*`}
                id="reason-field"
                multiline
                rows={5}
                fullWidth
                value={reason}
                onChange={handleReasonChange}
                size="small"
                placeholder={t('cm:deleteReasonHelper')}
                helperText={
                    <CharactersRemaining
                        id="helper-reason-field"
                        length={reason.length}
                        max={textFieldMaxLength}
                        error={reasonError}
                    />
                }
                variant="outlined"
                color="secondary"
                className={`${textFieldMaxLength - reason.length < 0 ? 'mb red-border' : 'mb'}`}
            />
        </ActionDialog>
    );
};

export default DeleteReasonDialog;
